import { Link } from 'react-router-dom';
import { siteInfo, categories } from '@/mocks/articles';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-secondary-950 text-background-200">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="py-12 md:py-16 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <div className="w-8 h-8 flex items-center justify-center bg-primary-500 rounded-lg">
                <i className="ri-vip-crown-line text-base text-background-50"></i>
              </div>
              <span className="font-heading text-lg font-semibold text-background-50">{siteInfo.name}</span>
            </div>
            <p className="text-sm text-background-400 leading-relaxed">{siteInfo.description.slice(0, 80)}...</p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-100 mb-4">快速导航</h4>
            <ul className="space-y-2.5">
              <li><Link to="/" className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer">首页</Link></li>
              <li><Link to="/category/platform-recommend" className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer">平台推荐</Link></li>
              <li><Link to="/category/bonus-guide" className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer">领取攻略</Link></li>
              <li><Link to="/about" className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer">关于我们</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-100 mb-4">彩金分类</h4>
            <ul className="space-y-2.5">
              {categories.slice(0, 5).map((cat) => (
                <li key={cat.slug}>
                  <Link to={`/category/${cat.slug}`} className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer">{cat.name}</Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-100 mb-4">联系我们</h4>
            <ul className="space-y-2.5">
              <li className="flex items-center gap-2 text-sm text-background-400">
                <i className="ri-mail-line text-primary-500 w-4 h-4 flex items-center justify-center"></i>
                {siteInfo.email}
              </li>
              <li className="flex items-center gap-2 text-sm text-background-400">
                <i className="ri-phone-line text-primary-500 w-4 h-4 flex items-center justify-center"></i>
                {siteInfo.phone}
              </li>
              <li className="flex items-center gap-2 text-sm text-background-400">
                <i className="ri-map-pin-line text-primary-500 w-4 h-4 flex items-center justify-center"></i>
                {siteInfo.address}
              </li>
            </ul>
          </div>
        </div>

        <div className="py-6 border-t border-background-800/40 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-background-500">© {currentYear} {siteInfo.name} 版权所有 | 本站内容仅供参考</p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-xs text-background-500 hover:text-primary-400 transition-colors cursor-pointer" rel="nofollow">隐私政策</a>
            <a href="#" className="text-xs text-background-500 hover:text-primary-400 transition-colors cursor-pointer" rel="nofollow">免责声明</a>
            <a href="#" className="text-xs text-background-500 hover:text-primary-400 transition-colors cursor-pointer" rel="nofollow">用户协议</a>
          </div>
        </div>
      </div>
    </footer>
  );
}